import { render } from "./UserAdministratorUnblockButton.vue?vue&type=template&id=12486e2d"
import script from "./UserAdministratorUnblockButton.vue?vue&type=script&lang=js"
export * from "./UserAdministratorUnblockButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__